import { render, staticRenderFns } from "./DistributionMailsDataTable.vue?vue&type=template&id=c508352c&scoped=true"
import script from "./DistributionMailsDataTable.vue?vue&type=script&lang=js"
export * from "./DistributionMailsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c508352c",
  null
  
)

export default component.exports